"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var CleanerModule = /** @class */ (function (_super) {
    __extends(CleanerModule, _super);
    function CleanerModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 修改培训内容
     * @param contentUrl  培训内容url
     * @param coverUrl  封面图url
     * @param displayState  显示状态
     * @param id
     * @param trainingItem  培训主题
     * @param trainingModule  培训模块
     * @param trainingName  	培训内容名称
     * @param token
     */
    CleanerModule.prototype.editTrainContent = function (params, token) {
        return this.gatewayClient.editTrainContent(params, token);
    };
    /**
     * 删除培训
     * @param id
     * @param token
     */
    CleanerModule.prototype.deleteTrainContent = function (id, token) {
        return this.gatewayClient.deleteTrainContent(id, token);
    };
    /**
     * 培训内容列表
     * @param token
     */
    CleanerModule.prototype.trainContentList = function (page, rows, token) {
        return this.gatewayClient.trainContentList(page, rows, token);
    };
    /**
     * 新增培训内容
     * @param contentUrl 网址链接
     * @param coverUrl 封面图url
     * @param displayState 显示状态
     * @param trainingItem 培训主题
     * @param trainingModule 培训模块
     * @param trainingName 培训内容名称
     * @param token
     */
    CleanerModule.prototype.addTrainContent = function (params, token) {
        return this.gatewayClient.addTrainContent(params, token);
    };
    ///////////////////////////// 清洁单 ////////////////////////////////////////
    /**
     * 今日清洁单数据
     */
    CleanerModule.prototype.findTodayData = function (token) {
        return this.gatewayClient.findTodayData(token);
    };
    /**
     * 查询所有房间
     * @param chainId 门店Id
     */
    CleanerModule.prototype.queryRoomListForCleanOrder = function (params, token) {
        return this.gatewayClient.queryRoomListForCleanOrder(params, token);
    };
    /**
     * 查询所有门店
     */
    CleanerModule.prototype.queryChainListForCleanOrder = function (token) {
        return this.gatewayClient.queryChainListForCleanOrder(token);
    };
    /**
     * 查询扣费项列表
     * @param page 页数
     * @param pageSize 行数
     */
    CleanerModule.prototype.queryPnsFeeCostList = function (page, pageSize, token) {
        return this.gatewayClient.queryPnsFeeCostList(page, pageSize, token);
    };
    /**
     * 清洁单查询
     * @param serviceDateStart 服务时间起
     * @param city 城市
     * @param orderStatus 清洁单状态（0未接单，1已接单，2到达房间，3开门成功，4清洁盘点完成，5离房成功，6已核查
     * @param xbedOrderNo xbed订单号
     * @param cleaner 接单人（姓名或手机号）
     * @param orderNo 清洁单号
     * @param cleanTypeId 清洁类型Id
     * @param hotspotId 热点Id
     * @param chainId 门店Id
     * @param startDate 创建日期起
     * @param roomName 房号
     * @param serviceDateEnd 服务时间止
     * @param pageSize 行数
     * @param page 页数
     * @param orderType 单类型（1.正常清洁单，2.指派清洁单，3.人工结单，4.取消清洁单，5自动派单）
     * @param endDate 创建日期止
     */
    CleanerModule.prototype.queryCleanOrderList = function (params, token) {
        return this.gatewayClient.queryCleanOrderList(params, token);
    };
    /**
     * 人工建单
     * @param xbedCheckinId xbed入住单号
     * @param plan 触发方案
     * @param xbedOrderNo xbed订单号
     * @param roomId 房间Id
     * @param cleanSource 来源（OMS人工建单为3）
     * @param createName 创建人
     * @param serviceDate 服务时间
     */
    CleanerModule.prototype.addCleanOrder = function (params, token) {
        return this.gatewayClient.addCleanOrder(params, token);
    };
    /**
     * 取消清洁单
     * @param cancelReason 取消原因
     * @param id 清洁单Id
     * @param updateName 更新人
     * @param updateRoomStatusSwitch 是否修改房态：1是，0否
     */
    CleanerModule.prototype.cancelCleanOrder = function (cancelReason, id, updateName, updateRoomStatusSwitch, token) {
        return this.gatewayClient.cancelCleanOrder(cancelReason, id, updateName, updateRoomStatusSwitch, token);
    };
    /**
     * 指派单
     * @param id 清洁单Id
     * @param cleanerAccount 管家账号
     * @param updateName 更新人
     */
    CleanerModule.prototype.assignCleanOrder = function (id, cleanerAccount, updateName, token) {
        return this.gatewayClient.assignCleanOrder(id, cleanerAccount, updateName, token);
    };
    /**
     * 查询物品设置
     * @param roomId 房间Id
     * @param plan 触发方案
     */
    CleanerModule.prototype.findItemType = function (roomId, plan, token) {
        return this.gatewayClient.findItemType(roomId, plan, token);
    };
    /**
     * 根据清洁单Id查询扣费项
     * @param cleanOrderId 清洁单Id
     */
    CleanerModule.prototype.queryListCostByCleanOrderId = function (cleanOrderId, token) {
        return this.gatewayClient.queryListCostByCleanOrderId(cleanOrderId, token);
    };
    /**
     * 清洁单接单日志
     * @param id 清洁单Id
     */
    CleanerModule.prototype.findCleanOrderLogs = function (id, token) {
        return this.gatewayClient.findCleanOrderLogs(id, token);
    };
    /**
     * 清洁单留言查询
     * @param cleanOrderId 清洁单Id
     */
    CleanerModule.prototype.queryCleanOrderMessageList = function (cleanOrderId, token) {
        return this.gatewayClient.queryCleanOrderMessageList(cleanOrderId, token);
    };
    /**
     * 结束清洁单
     * @param updateName 更新人
     * @param id 清洁单Id
     */
    CleanerModule.prototype.overCleanOrder = function (updateName, id, finishReason, token) {
        return this.gatewayClient.overCleanOrder(updateName, id, finishReason, token);
    };
    /**
     * 已通过审核管家账号
     * @param page 页码
     * @param size 每页的数量
     * @param account 手机号
     * @param userName 管家名字
     */
    CleanerModule.prototype.cleanerAccountAcceptData = function (params, token) {
        return this.gatewayClient.getCleanerAccountAcceptData(params, token);
    };
    /**
     * 清洁单图片查询
     * @param cleanOrderId 清洁单Id
     */
    CleanerModule.prototype.findImgsByCleanOrderId = function (cleanOrderId, token) {
        return this.gatewayClient.findImgsByCleanOrderId(cleanOrderId, token);
    };
    /**
     * 热点工作人员
     */
    CleanerModule.prototype.findHotSpotCleaner = function (token) {
        return this.gatewayClient.findHotSpotCleaner(token);
    };
    /**
     * 城市/热点/门店联动查询
     * @param city 指定城市
     * @param sourceId 指定查询一条记录
     * @param type 查询类型 0 查询所有 1查询热点 2查询门店
     * @param token
     */
    CleanerModule.prototype.querySelectListForCleanOrder = function (params, token) {
        return this.gatewayClient.querySelectListForCleanOrder(params, token);
    };
    /**
     * 查询核查记录
     * @param cleanOrderId 清洁单Id
     */
    CleanerModule.prototype.findCheckDetailForCleanOrder = function (cleanOrderId, token) {
        return this.gatewayClient.findCheckDetailForCleanOrder(cleanOrderId, token);
    };
    /**
     * 易耗品补充记录查询
     * @param cleanOrderId 清洁单Id
     * @param token
     */
    CleanerModule.prototype.findConsumableForCleanOrder = function (cleanOrderId, token) {
        return this.gatewayClient.findConsumableForCleanOrder(cleanOrderId, token);
    };
    ///////////////////////////// 清洁单 ////////////////////////////////////////
    /////////////////////////// 物品管理 ///////////////////////////////////////
    /**
     * 物品管理 -&gt;删除物品
     * @param goodsId 物品Id
     * @param updateName 更新人
     */
    CleanerModule.prototype.delGoodsForCleanerGoodsList = function (goodsId, updateName, token) {
        return this.gatewayClient.delGoodsForCleanerGoodsList(goodsId, updateName, token);
    };
    /**
     * 物品管理 -&gt;新增物品
     * @param goodsAttribute 属性
     * @param goodsDesc 规格
     * @param goodsModel 型号/品牌
     * @param goodsCatalog 一级类型
     * @param createName 创建人
     * @param isStandard 是否标配
     * @param secondaryCatalog 二级类型
     * @param goodsName 物品名称
     * @param remark 备注
     * @param stockNumber 进销存产品编号
     */
    CleanerModule.prototype.addGoodsForCleanerGoodsList = function (params, token) {
        return this.gatewayClient.addGoodsForCleanerGoodsList(params, token);
    };
    /**
     * 物品管理 -&gt;核查设置
     * @param unit 核查数量
     * @param goodsId 物品Id
     * @param checkOptions 核查步骤
     * @param updateName
     * @param checkPic 核查图片（url）
     * @param checkType 核查类型（0不核查 1数量标准 2步骤标准 3数量+步骤）
     */
    CleanerModule.prototype.setGoodsCheckForCleanerGoodsList = function (params, token) {
        return this.gatewayClient.setGoodsCheckForCleanerGoodsList(params, token);
    };
    /**
     * 物品管理 -&gt;物品列表
     * @param pageSize 行数
     * @param isStandard 是否标配（1是0否）
     * @param page 页数
     * @param goodsName 名称
     * @param secondaryCatalog 二级类别
     * @param goodsAttribute 属性
     * @param checkType 核查类型
     * @param stockNumber 物料编号
     * @param goodsCatalog 物品类别（一级类别）
     */
    CleanerModule.prototype.queryCleanerGoodsList = function (params, token) {
        return this.gatewayClient.queryCleanerGoodsList(params, token);
    };
    /**
     * 物品管理 -&gt;物品类别下拉列表
     * @param parentId 父级Id
     */
    CleanerModule.prototype.getSelectiveForCleanerGoodsList = function (params, token) {
        return this.gatewayClient.getSelectiveForCleanerGoodsList(params, token);
    };
    /**
     * 物品管理 -&gt;修改物品
     * @param goodsAttribute 属性
     * @param goodsName 物品名称
     * @param goodsModel 型号/品牌
     * @param isStandard 是否标配
     * @param secondaryCatalog 二级类型
     * @param goodsId 物品Id
     * @param remark 备注
     * @param goodsCatalog 一级类型
     * @param goodsDesc 规格
     * @param updateName 创建人
     * @param stockNumber 进销存产品编号
     * @param terminal 应用终端1xbed 2房东端 3xbed+房东端
     */
    CleanerModule.prototype.editGoodsForCleanerGoodsList = function (params, token) {
        return this.gatewayClient.editGoodsForCleanerGoodsList(params, token);
    };
    /**
     * 物品管理 -&gt;获取所有物品类别
     * @param token
     */
    CleanerModule.prototype.getGoodsCatalogList = function (token) {
        return this.gatewayClient.getGoodsCatalogList(token);
    };
    /////////////////////////// 物品管理 ///////////////////////////////////////
    /////////////////////////// 清洁项目管理 ///////////////////////////////////////
    /**
     * 清洁步骤项目管理-&gt;项目列表
     * @param pageSize
     * @param page
     * @param search 查询关键字
     */
    CleanerModule.prototype.cleanStepList = function (params, token) {
        return this.gatewayClient.cleanStepList(params, token);
    };
    /**
     * 清洁步骤项目管理-&gt;新增项目
     * @param createName
     * @param description 描述
     * @param name 名称
     */
    CleanerModule.prototype.cleanStepAdd = function (params, token) {
        return this.gatewayClient.cleanStepAdd(params, token);
    };
    /**
     * 清洁步骤项目管理-&gt;编辑项目
     * @param updateName 更新人
     * @param used 是否可用
     * @param id
     * @param description 描述
     * @param name 项目名称
     */
    CleanerModule.prototype.cleanStepEdit = function (params, token) {
        return this.gatewayClient.cleanStepEdit(params, token);
    };
    /**
     * 清洁步骤项目管理-&gt;删除项目
     * @param id 步骤项目Id
     */
    CleanerModule.prototype.cleanStepDel = function (id, token) {
        return this.gatewayClient.cleanStepDel(id, token);
    };
    /**
     * 核查项目管理 -&gt; 核查项目列表
     * @param pageSize 行数
     * @param page 页数
     */
    CleanerModule.prototype.cleanCheckList = function (params, token) {
        return this.gatewayClient.cleanCheckList(params, token);
    };
    /**
     * 核查项目管理 -&gt; 新建核查项目
     * @param name 项目名称
     * @param type 核查类型(1关联物品,2无物品)
     * @param goodsIds 关联物品Id(type&#x3D;2时不传)
     * @param createName 创建人
     * @param pic 核查图片
     * @param detail 核查明细(json数组，type&#x3D;1时不传)
     * @param checkTime 核查时间(ms)
     */
    CleanerModule.prototype.cleanCheckAdd = function (params, token) {
        return this.gatewayClient.cleanCheckAdd(params, token);
    };
    /**
     * 核查项目管理 -&gt; 删除核查项目
     * @param id 项目Id
     */
    CleanerModule.prototype.cleanCheckDel = function (id, token) {
        return this.gatewayClient.cleanCheckDel(id, token);
    };
    /**
     * 核查项目管理 -&gt; 编辑核查项目
     * @param pic 核查图片
     * @param checkTime 核查时间(ms)
     * @param type 核查类型(1关联物品,2无物品)
     * @param detail 核查明细(json数组，type&#x3D;1时不传)
     * @param name 项目名称
     * @param id 项目Id
     * @param createName 创建人
     * @param goodsIds 关联物品Id(type&#x3D;2时不传)
     */
    CleanerModule.prototype.cleanCheckEdit = function (params, token) {
        return this.gatewayClient.cleanCheckEdit(params, token);
    };
    /**
     * 核查项目管理 -&gt; 获取可选物品列表
     * @param goodsName 物品名称
     * @param checkObjectId 核查项目Id
     * @param secondaryCatalog 二级类型
     * @param goodsCatalog 一级类型
     * @param isStandard 是否标配 1是0否
     */
    CleanerModule.prototype.getCleanCheckGoodsList = function (params, token) {
        return this.gatewayClient.getCleanCheckGoodsList(params, token);
    };
    /////////////////////////// 清洁项目管理 ///////////////////////////////////////
    /////////////////////////// 清洁单类型管理 ///////////////////////////////////////
    /**
     * 清洁类型管理 -&gt; 清洁类型列表
     * @param page 页数
     * @param pageSize 行数
     * @param search 关键字
     */
    CleanerModule.prototype.queryListForCleanType = function (params, token) {
        return this.gatewayClient.queryListForCleanType(params, token);
    };
    /**
     * 清洁类型管理 -&gt; 新建清洁类型
     * @param description 描述
     * @param itemDetail 项目明细(逗号&quot;,&quot;分割)；1更换床品，2更换毛巾，3补充易耗品
     * @param name 名称
     * @param itemType 项目配置类型：1固定配置，2建单时人工配置
     * @param createName 创建人
     */
    CleanerModule.prototype.addCleanType = function (params, token) {
        return this.gatewayClient.addCleanType(params, token);
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型
     * @param itemType 项目配置类型：1固定配置，2建单时人工配置
     * @param name 名称
     * @param itemDetail 项目明细(逗号&quot;,&quot;分割)；1更换床品，2更换毛巾，3补充易耗品
     * @param updateName 更新人
     * @param used 是否可用（1是0否） 传0即为删除该项目
     * @param description 备注
     * @param id
     */
    CleanerModule.prototype.editCleanType = function (params, token) {
        return this.gatewayClient.editCleanType(params, token);
    };
    /**
     * 清洁类型管理 -&gt; 清洁项目列表
     * @param cleanTypeId 清洁类型Id
     */
    CleanerModule.prototype.queryListObjectForCleanType = function (cleanTypeId, token) {
        return this.gatewayClient.queryListObjectForCleanType(cleanTypeId, token);
    };
    /**
     * 清洁类型管理 -&gt; 删除清洁类型-项目关系
     * @param cleanTypeId
     */
    CleanerModule.prototype.delObjectForCleanType = function (cleanTypeId, token) {
        return this.gatewayClient.delObjectForCleanType(cleanTypeId, token);
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型-项目关系
     * @param data
     */
    CleanerModule.prototype.editObjectForCleanType = function (data, token) {
        return this.gatewayClient.editObjectForCleanType(data, token);
    };
    /**
     * 清洁类型管理 -&gt; 核查项目列表
     * @param cleanTypeId 清洁类型Id
     */
    CleanerModule.prototype.queryListCheckObject = function (cleanTypeId, token) {
        return this.gatewayClient.queryListCheckObject(cleanTypeId, token);
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型-核查项目关系
     * @param data
     */
    CleanerModule.prototype.editCheckObject = function (data, token) {
        return this.gatewayClient.editCheckObject(data, token);
    };
    /**
     * 清洁类型管理 -&gt; 删除清洁类型-核查项目关系
     * @param cleanTypeId
     */
    CleanerModule.prototype.delCheckObject = function (cleanTypeId, token) {
        return this.gatewayClient.delCheckObject(cleanTypeId, token);
    };
    /**
     * 获取核查物品列表
     * @param token
     */
    CleanerModule.prototype.getGoodsList = function (token) {
        return this.gatewayClient.getGoodsList(token);
    };
    /////////////////////////// 清洁单类型管理 ///////////////////////////////////////
    /////////////////////////// 管家信息账号管理 ///////////////////////////////////////
    /**
     * 管家列表
     * @param accept 状态（是否可接单 1是0否 -1全部）
     * @param account 管家账号
     * @param isAuth 是否已认证（1是 0否 -1全部）
     * @param userName 用户名
     * @param page
     * @param size
     * @param token
     */
    CleanerModule.prototype.queryCleanerList = function (params, token) {
        return this.gatewayClient.queryCleanerList(params, token);
    };
    /**
     * 开通/禁止接单
     * @param accept 状态（是否可接单 1是0否）
     * @param id 管家Id
     * @param updateName 操作人
     * @param token
     */
    CleanerModule.prototype.acceptCleaner = function (params, token) {
        return this.gatewayClient.acceptCleaner(params, token);
    };
    /**
     * 开通/禁止查房
     * @param id 管家Id
     * @param isWatcher 是否是查房者（1是 0否）
     * @param updateName 操作人
     * @param token
     */
    CleanerModule.prototype.watcherCleaner = function (params, token) {
        return this.gatewayClient.watcherCleaner(params, token);
    };
    /**
     * 修改管家信息
     * @param bankBranchName 支行名
     * @param bankName 开户行
     * @param bankNo 银行账号
     * @param cardId 身份证号
     * @param city 城市
     * @param deposit 押金
     * @param district 区县
     * @param hotspotId 热点ID
     * @param hotspotName 热点名称
     * @param id 管家id
     * @param isAgree 是否签订协议
     * @param isAuth 是否身份认证
     * @param province 省份
     * @param remark 备注
     * @param updateName 操作人
     * @param userName 用户名
     * @param token
     */
    CleanerModule.prototype.editCleanerList = function (params, token) {
        return this.gatewayClient.editCleanerList(params, token);
    };
    /**
     * 获取热点列表
     * @param cityName 城市名称
     * @param token
     */
    CleanerModule.prototype.queryCleanerHotspotList = function (cityName, token) {
        return this.gatewayClient.queryCleanerHotspotList(cityName, token);
    };
    /**
     * 管家详情
     * @param id 管家id
     * @param token
     */
    CleanerModule.prototype.queryCleanerInfo = function (id, token) {
        return this.gatewayClient.queryCleanerInfo(id, token);
    };
    /**
     * 房东信息列表
     * @param createDateEnd 创建日期止（yyyy-MM-dd）
     * @param createDateStart 创建日期起（yyyy-MM-dd）
     * @param examineState 身份验证状态（1未验证 2未审核 3审核通过 4审核失败）
     * @param lastLoginEnd 最后登录日期止（yyyy-MM-dd）
     * @param lastLoginStart 最后登录日期起（yyyy-MM-dd）
     * @param mobile 电话号码
     * @param name 姓名
     * @param page 页数
     * @param size 行数
     * @param source 注册来源
     * @param token
     */
    CleanerModule.prototype.queryLandlordList = function (params, token) {
        return this.gatewayClient.queryLandlordList(params, token);
    };
    /////////////////////////// 管家信息账号管理 ///////////////////////////////////////
    /////////////////////////// 中心仓管理 ///////////////////////////////////////
    /**
     * 中心仓城市列表
     * @param token
     */
    CleanerModule.prototype.centerCityList = function (params, token) {
        return this.gatewayClient.centerCityList(params, token);
    };
    /**
     * 中心仓省列表
     * @param token
     */
    CleanerModule.prototype.centerProvinceList = function (params, token) {
        return this.gatewayClient.centerProvinceList(params, token);
    };
    /**
     * 城市中心仓列表
     * @param city 城市（Id）
     * @param page 页数
     * @param phone 联系电话
     * @param size  页大小
     * @param status 状态（1启用 0停用 -1全部）
     * @param token
     */
    CleanerModule.prototype.centerManagementList = function (params, token) {
        return this.gatewayClient.centerManagementList(params, token);
    };
    /**
     * 新建中心仓
     * @param city 城市
     * @param cityId 城市Id
     * @param createName 创建人（oms用户名）
     * @param district  区县
     * @param districtId 区县Id
     * @param latitude 纬度
     * @param longitude 经度
     * @param phone 联系电话
     * @param province  省份
     * @param provinceId 省份Id
     * @param repositoryName 仓库名称
     * @param status  状态（1启用 0停用）
     * @param stressAddress 街道地址
     * @param token
     */
    CleanerModule.prototype.addCenterManagement = function (params, token) {
        return this.gatewayClient.addCenterManagement(params, token);
    };
    /**
     * 编辑中心仓
     * @param city 城市
     * @param cityId 城市Id
     * @param district  区县
     * @param districtId 区县Id
     * @param latitude 纬度
     * @param longitude 经度
     * @param phone 联系电话
     * @param province  省份名称
     * @param provinceId 省份Id
     * @param repositoryName 仓库名称
     * @param status  状态（1启用 0停用）
     * @param stressAddress 街道地址
     * @param updateName 更新人
     * @param token
     * @param id 中心仓Id
     */
    CleanerModule.prototype.editCenterManagement = function (params, token) {
        return this.gatewayClient.editCenterManagement(params, token);
    };
    /**
     * 城市中心仓数量
     * @param citys 城市中文编码LIst
     * @param token
     */
    CleanerModule.prototype.centerManagementHouseNum = function (param, token) {
        return this.gatewayClient.centerManagementHouseNum(param, token);
    };
    /**
     * 管家信息修改记录
     * @param cleanerId 管家Id（Id）
     * @param page 页数
     * @param size  行数
     * @param token
     */
    CleanerModule.prototype.editHousekeeperAccount = function (params, token) {
        return this.gatewayClient.editHousekeeperAccount(params, token);
    };
    /**
     * 管家即时账务列表
     * @param params
     * @param token
     */
    CleanerModule.prototype.getHostInfos = function (params, token) {
        return this.gatewayClient.getHostInfos(params, token);
    };
    /**
     * 管家身份信息
     * @param id
     * @param token
     */
    CleanerModule.prototype.getVerifyInfo = function (params, token) {
        return this.gatewayClient.getVerifyInfo(params, token);
    };
    /**
     * 人脸验证
     *@param cleanerId 	管家Id
     *@param imageCode  人脸验证图片
     *@param token
     */
    CleanerModule.prototype.faceRecognition = function (params, token) {
        return this.gatewayClient.faceRecognition(params, token);
    };
    /**
     * 身份证上传验证
     *@param cleanerId 管家Id
     *@param cardBackImgCode 	身份证背面图
     *@param cardFrontImgCode 身份证正面图
     *@param updateName 操作人
     *@param token
     */
    CleanerModule.prototype.authentication = function (params, token) {
        return this.gatewayClient.authentication(params, token);
    };
    /////////////////////////// 中心仓管理 ///////////////////////////////////////
    /**
     * 获取易耗品列表或根据名字查询
     */
    CleanerModule.prototype.consumableList = function (params, token) {
        return this.gatewayClient.consumableList(params, token);
    };
    /**
     * 修改易耗品价格
     */
    CleanerModule.prototype.editConsumPrice = function (cityId, goodsList, token) {
        return this.gatewayClient.editConsumPrice(cityId, goodsList, token);
    };
    /**
     * 获获取布草列表或根据城市名称、商品名称查询
     */
    CleanerModule.prototype.washingList = function (params, token) {
        return this.gatewayClient.washingList(params, token);
    };
    /**
     * 修改布草价格
     */
    CleanerModule.prototype.editWashingPrice = function (cityId, goodsList, token) {
        return this.gatewayClient.editWashingPrice(cityId, goodsList, token);
    };
    /**
     * 领用归还单列表
     * @param account 管家手机
     * @param invoiceId 领用归还单号
     * @param orderNo 单据编号
     * @param page 	页数
     * @param pageSize 	每页数据量
     * @param receiptsType 单据类别（1—领用，2—归还）
     * @param userName 	管家名字
     * @param beginDate 	起始时间
     * @param endDate 		终止时间
     * @param approvalStatus 		审批状态
     * @param createJxcOrderStatus 		生成状态
     * @param repositoryName 			中心仓名
     * @param associatedCityName 			关联城市名
     */
    CleanerModule.prototype.MmReceiptReturnList = function (params, token) {
        return this.gatewayClient.MmReceiptReturnList(params, token);
    };
    /**
     * 根据领用归还表确认领用/归还
     * @param id 领用归还表id
     * @param updateName 	操作人
     */
    CleanerModule.prototype.affirmReceive = function (params, token) {
        return this.gatewayClient.affirmReceive(params, token);
    };
    /**
     * 根据领用归还单号查询商品集合（查看详情）
     *  @param invoiceId 领用归还单号
     */
    CleanerModule.prototype.MmReceiptReturnGoods = function (invoiceId, token) {
        return this.gatewayClient.MmReceiptReturnGoods(invoiceId, token);
    };
    /**
     * 管家物资详情表
     * @param associatedNumber 	关联单号
     * @param associatedRepositoryName 关联中心仓
     * @param associatedRoomName 	关联房间
     * @param beginDate 	查询更新时间的开始
     * @param endDate 查询更新时间的结尾）
     * @param entryExitType 		出入库类型
     * @param goodsCatalog 	一级类目
     * @param goodsName 	商品名字
     * @param page 	页数
     * @param pageSize 	每页数据量
     * @param updateType 	更新类型
     * @param cleanerId 	管家id
     * @param goodsId 	物品id
     * @param associatedCityName 	关联城市名
     */
    CleanerModule.prototype.MmStewardGoodsInventoryParticular = function (params, token) {
        return this.gatewayClient.MmStewardGoodsInventoryParticular(params, token);
    };
    /**
     * 管家物资月表
     * @param month 时间
     * @param cleanerAccount 管家手机
     * @param cleanerName 	管家名字
     * @param goodsName 		  商品名字
     * @param page 		        页数
     * @param pageSize 		   每页数据量
     * @param stockNumber 	 	 物料编号
     * @param associatedCityName 	 	 关联城市名
     */
    CleanerModule.prototype.MmMonthlyStewardGoodsInventory = function (params, token) {
        return this.gatewayClient.MmMonthlyStewardGoodsInventory(params, token);
    };
    /**
     * 获取管家月表所有管家
     */
    CleanerModule.prototype.MmMonthlygetCleanerList = function (params, token) {
        return this.gatewayClient.MmMonthlygetCleanerList(params, token);
    };
    /**
     * 获取房间月表所有房间
     */
    CleanerModule.prototype.MmMonthlygetRoomList = function (params, token) {
        return this.gatewayClient.MmMonthlygetRoomList(params, token);
    };
    /*
     * 房间出入库表
     */
    CleanerModule.prototype.roomGoodInventoryList = function (params, token) {
        return this.gatewayClient.roomGoodInventoryList(params, token);
    };
    /*
     * 房间出入库明细表
     * @param endDate 截至时间
     * @param entryExitType 	出入库类型
     * @param goodsName 		  商品名字
     * @param page 		        页数
     * @param pageSize 		   每页数据量
     * @param stockNumber 	 	 物料编号
     * @param associatedCityName 	 	 关联城市名
     */
    CleanerModule.prototype.roomGoodInventoryDetailList = function (params, token) {
        return this.gatewayClient.roomGoodInventoryDetailList(params, token);
    };
    /*
  * 获取房间易耗品和布草列表
  * @param cleanOrderId 清洁单Id
  * @param goodsAttribute 		物品属性
  * @param roomId 		  房间Id
  */
    CleanerModule.prototype.queryRoomGoodsList = function (params, token) {
        return this.gatewayClient.queryRoomGoodsList(params, token);
    };
    /*
  * 录入物品更换补充数据
  * @param cleanOrderId 清洁单Id
  * @param createName 		修改人
  * @param goodsId 		  物品Id
  * @param goodsName 		物品名称
  * @param num 		  数量
  * @param type 		  类型 3补充 4更换
  */
    CleanerModule.prototype.postAddDamageGoods = function (cleanOrderId, goodsDamageList, token) {
        return this.gatewayClient.postAddDamageGoods(cleanOrderId, goodsDamageList, token);
    };
    /*
    * 销售单列表
    * @param beginDate 	起始时间
    * @param cleanOrderNo 		清洁单号
    * @param consumableSellState 	生成状态
    * @param endDate 		  终止时间
    * @param repositoryName 	中心仓名
    * @param consumableSellOrderNo 	单据编号
    * @param associatedCityName 	关联城市名
    */
    CleanerModule.prototype.sellListingList = function (params, token) {
        return this.gatewayClient.sellListingList(params, token);
    };
    /*
    * 销售出库单的商品
    * @param consumableSellOrderId 	销售出库单id
    */
    CleanerModule.prototype.sellListingGoodsList = function (params, token) {
        return this.gatewayClient.sellListingGoodsList(params, token);
    };
    /*
    * 关联中心仓辐射城市
    * @param counties 	区县级集合
    * @param province 	省份名称
    * @param provinceId 	省份id
    * @param repositoryId 	中心仓id
    * @param createName
    */
    CleanerModule.prototype.postAddDistrict = function (params, token) {
        return this.gatewayClient.postAddDistrict(params, token);
    };
    /**
    * 值班单列表
    * @param buildingAddress  值班地点
    * @param cleaner 	管家姓名/电话
    * @param contactPhone 	联系电话
    * @param createDateEnd 		创建日期止
    * @param createDateStart 	创建日期起
    * @param createName 	建单人
    * @param dutyDateEnd 	创建日期起
    * @param dutyDateStart 	值班日期止
    * @param dutyOrderNo  	值班单号
    * @param orderStatus 	订单进度
    * @param orderType 	单状态
    * @param page 	页数
    * @param search 	搜索值
    * @param size 		行数
    */
    CleanerModule.prototype.queryXbDutyOrderList = function (params, token) {
        return this.gatewayClient.queryXbDutyOrderList(params, token);
    };
    /**
    * 值班单列表
    * @param buildingId  楼宇Id
    * @param cleanerId	 	管家Id
    * @param contactPhone 	联系电话
    * @param content 		工作内容
    * @param createName 		建单人
    * @param price 	薪酬(分)
    * @param serviceDate 	服务日期
    * @param serviceEndTime 	服务时间止
    * @param serviceStartTime 	服务时间起
    */
    CleanerModule.prototype.postXbDutyOrderAdd = function (params, token) {
        return this.gatewayClient.postXbDutyOrderAdd(params, token);
    };
    /**
    * 取消值班单
    * @param dutyOrderId  值班单Id
    * @param updateName	 	操作人
    */
    CleanerModule.prototype.xbDutyOrderCancelOrder = function (params, token) {
        return this.gatewayClient.xbDutyOrderCancelOrder(params, token);
    };
    /**
    * 指派值班单
    * @param cleanerId  管家Id
    * @param dutyOrderId	 	值班单Id
    * @param updateName	 	值班单Id
    */
    CleanerModule.prototype.xbDutyOrderAssignOrder = function (params, token) {
        return this.gatewayClient.xbDutyOrderAssignOrder(params, token);
    };
    /**
    * 查看值班单日志
    * @param dutyOrderId	 	值班单Id
    */
    CleanerModule.prototype.queryXbDutyOrderFindLog = function (params, token) {
        return this.gatewayClient.queryXbDutyOrderFindLog(params, token);
    };
    /**
    * 查看工作内容
    * @param dutyOrderId	 	值班单Id
    */
    CleanerModule.prototype.queryXbDutyOrderGetContent = function (params, token) {
        return this.gatewayClient.queryXbDutyOrderGetContent(params, token);
    };
    /**
    * 结束值班单
    * @param dutyOrderId	 	值班单Id
    * @param updateName	 	操作人
    */
    CleanerModule.prototype.xbDutyOrderOverDutyOrder = function (params, token) {
        return this.gatewayClient.xbDutyOrderOverDutyOrder(params, token);
    };
    /**
    * 获取楼宇权限列表
    */
    CleanerModule.prototype.queryXbDutyOrderGetBuildingList = function (token) {
        return this.gatewayClient.queryXbDutyOrderGetBuildingList(token);
    };
    /**
    * 获取楼宇权限列表
    * @params createDateEnd   创建日期止
    * @params createDateStart   创建日期起
    * @params page   页数
    * @params settlementDateEnd   结算日期止
    * @params settlementDateStart 结算日期起
    * @params size   行数
    * @params status   状态
    */
    CleanerModule.prototype.queryXbcleanXbDutyBillList = function (params, token) {
        return this.gatewayClient.queryXbcleanXbDutyBillList(params, token);
    };
    return CleanerModule;
}(gateway_module_1.GatewayModule));
exports.CleanerModule = CleanerModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/cleaner/index.js
// module id = 209
// module chunks = 44